export const reduxKey = '@@WHO';
export const streamType = '@@WHO';
export const actionKey = '@@WHO';
